import { render, staticRenderFns } from "./FlowCustomize.vue?vue&type=template&id=7a5a12f8&scoped=true&"
import script from "./FlowCustomize.vue?vue&type=script&lang=js&"
export * from "./FlowCustomize.vue?vue&type=script&lang=js&"
import style0 from "./FlowCustomize.vue?vue&type=style&index=0&id=7a5a12f8&prod&lang=scss&"
import style1 from "./FlowCustomize.vue?vue&type=style&index=1&id=7a5a12f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5a12f8",
  null
  
)

export default component.exports